import React, { Component } from 'react';
import OrderStatusBadge from 'src/components/Shared/OrderStatusBadge';


export default class InfoCard extends Component {

    transferBadge (status){
      if(status){
        if (status == "TRANSFER_SUCCESSFUL"){
          return <span className="badge badge-success">Transferido</span>
        }
        if (status == "TRANSFER_PENDING"){
          return <span className="badge badge-info">Pendente</span>
        }
        if (status == "TRANSFER_FAILED"){
          return <span className="badge badge-warning">Falhou</span>
        }
      }
      return <span className="badge badge-warning">Falhou</span>
    }

    render() {
        const { status, account, accountDigit, accountType, agency, agencyDigit, bankCode, cpfCnpj, name} = this.props;

        return (
            <div className="card shadow mb-5">
                <div className="card-header border-0">
                    <h3 className="mb-0">Detalhe da repasse</h3>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-6">
                            <ul className="list-group list-group-flush list my--3">
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                Nome
                                            </h5>
                                        </div>
                                        <div className="col-auto">{name}</div>
                                    </div>
                                </li>
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                CPF/CNPJ
                                            </h5>
                                        </div>
                                        <div className="col-auto">{cpfCnpj}</div>
                                    </div>
                                </li>
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                Status
                                            </h5>
                                        </div>
                                        <div className="col-auto">{this.transferBadge(status)}</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="col-6">
                            <ul className="list-group list-group-flush list my--3">
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                Agência
                                            </h5>
                                        </div>
                                        <div className="col-auto">{agency}{agencyDigit ? `-${agencyDigit}` : ""}</div>
                                    </div>
                                </li>
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                Conta
                                            </h5>
                                        </div>
                                        <div className="col-auto">{account}{accountDigit ? `-${accountDigit}` : ""}</div>
                                    </div>
                                </li>
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                Banco
                                            </h5>
                                        </div>
                                        <div className="col-auto">{bankCode}</div>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/CommissionsTransfers/Details/Details/InfoCard.js